"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedDocumentReadingHttpService = void 0;
const shared_document_reading_1 = require("../../types/shared-documents/shared-document-reading");
const http_service_1 = require("../http.service");
/**
 * Reading side of the shared-document space (#849): a reader's list and
 * badge, and a document's detail, file, opening and confirmation.
 */
class SharedDocumentReadingHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/documents`);
    }
    /**
     * Lists the documents shared with the current user, newest first.
     *
     * @returns Their documents with their status, and the unread and
     *   to-confirm counts.
     */
    getReceivedList() {
        return this.get('received', {
            schema: shared_document_reading_1.listReceivedSharedDocumentsApiResponseSchema,
        });
    }
    /**
     * Counts the current user's documents never opened.
     *
     * @returns The count.
     */
    getUnreadCount() {
        return this.get('received/unread-count', { schema: shared_document_reading_1.countUnreadSharedDocumentsApiResponseSchema });
    }
    /**
     * Shows one document; records nothing.
     *
     * @param id - The document.
     * @returns The document, the user's standing and who it was shared with.
     */
    getById(id) {
        return this.get(encodeURIComponent(id), {
            schema: shared_document_reading_1.getSharedDocumentApiResponseSchema,
        });
    }
    /**
     * Gets a five-minute presigned URL of the document's file; records nothing.
     *
     * @param id - The document.
     * @returns The URL.
     */
    getFileUrl(id) {
        return this.get(`${encodeURIComponent(id)}/file`, { schema: shared_document_reading_1.getSharedDocumentFileUrlApiResponseSchema });
    }
    /**
     * Records that the user opened the document; only the first time counts.
     *
     * @param id - The document.
     * @returns The user's standing.
     */
    open(id) {
        return this.post(`${encodeURIComponent(id)}/open`, { schema: shared_document_reading_1.recordSharedDocumentReadingApiResponseSchema });
    }
    /**
     * Records the user's "J'ai lu et compris" on a mandatory read, for good.
     *
     * @param id - The document.
     * @returns The user's standing.
     */
    confirm(id) {
        return this.post(`${encodeURIComponent(id)}/confirm`, { schema: shared_document_reading_1.recordSharedDocumentReadingApiResponseSchema });
    }
}
exports.SharedDocumentReadingHttpService = SharedDocumentReadingHttpService;
